import styled from 'styled-components';

export const KeyOption = styled.li`
  display: flex;
  align-items: center;

  & > svg {
    width: 1.25rem;
    margin-right: 1rem;
  }
`;

KeyOption.displayName = 'KeyOption';
